module.exports = __webpack_public_path__ + "img/app-academy-tutor-2.519cfb0a.png";